<template>
    <div>
        <div class="search-box">
            <p>部门：</p>
            <a-tree-select
            class="input-box"
            showSearch
            :value="searchFrom.orgCode"
            :treeData="departmentTree"
            :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择部门"
            allowClear
            treeNodeFilterProp="title"
            treeDefaultExpandAll
            @change="onChangeDep"
            >
            </a-tree-select>
            <p>用印类型：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.type" >
                <a-select-option  value="党章">党章</a-select-option>
                <a-select-option  value="行政公章">行政公章</a-select-option>
            </a-select>
            <p>教师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <p>状态：</p>
            <a-select class="input-box" style="width:11rem" allowClear v-model="searchFrom.approveStatus" >
                <a-select-option  value="draft">草稿</a-select-option>
                <a-select-option  value="commit">审批中</a-select-option>
                <a-select-option  value="approved">审批通过</a-select-option>
                <a-select-option  value="reject">已驳回</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/office/seal/info?type=add')"
                v-if="permissions.indexOf('collegeOffice:stampsApplication:add')>-1"
                >
                 新增
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="remove()">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('collegeOffice:stampsApplication:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="seal('edit')"
                v-if="permissions.indexOf('collegeOffice:stampsApplication:edit')>-1">
                 编辑
            </a-button>
            <a-button type="primary" v-if="permissions.indexOf('collegeOffice:stampsApplication:query')>-1" class="btn" icon="file-search" @click="seal('look')">查看详情</a-button>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                @click="seal('approve')"
                v-if="permissions.indexOf('collegeOffice:stampsApplication:approve')>-1 || permissions.indexOf('collegeOffice:stampsApplication:approve1')>-1">
                 审批
            </a-button>
            <a-button type="primary" v-if="permissions.indexOf('collegeOffice:stampsApplication:approve')>-1 || permissions.indexOf('collegeOffice:stampsApplication:approve1')>-1" class="btn"  @click="selectedRowKeys[0] == null ? selectedCheck() : showBatchModal('批量审批')"><a-icon type="check" />批量审批</a-button>
            <a-button 
                type="primary"
                icon="export" 
                class="btn" 
                @click="exportFile(selectedRowKeys[0])"
                v-if="permissions.indexOf('collegeOffice:stampsApplication:export')>-1">
                 导出
            </a-button>
            <a-button 
                type="primary"
                icon="export" 
                class="btn" 
                @click="batchExportFile()"
                v-if="permissions.indexOf('collegeOffice:stampsApplication:export')>-1">
                 批量导出
            </a-button>
            <a-button type="primary" v-if="permissions.indexOf('collegeOffice:stampsApplication:exportXls	')>-1" class="btn"  @click="showExportModal('按时间导出')"><a-icon type="export" />按时间导出</a-button>
        </div>
        <a-table 
            rowKey='id' 
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>

        <a-modal
        :title="batchTitle"
        :visible="batchVisible"
        @ok="handleOk"
        @cancel="batchHandleCancel"
        :confirm-loading="batchConfirmLoading"
        width='35rem'
        >
            <template slot="footer">
                <a-button key="back" @click="batchHandleCancel">
                取消
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="batchSub('reject')">
                驳回
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="batchSub('approved')">
                通过
                </a-button>
            </template>

            <div class="info-main">
                <div class="input-box">
                    <p>审批意见：</p>
                    <a-textarea class="input" v-model="batchApproveInfo.approvalComments" :rows="3"></a-textarea>
                </div>
            </div>
        </a-modal>


        <a-modal
        :title="exportTitle"
        :visible="exportVisible"
        @cancel="exportHandleCancel"
        :confirm-loading="exportConfirmLoading"
        width='21%'
        >
            <template slot="footer">
                <a-button key="back" @click="exportHandleCancel">
                取消
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="exportXlsFile()">
                导出
                </a-button>
            </template>
            <div style="display:flex;">
                <p>时间范围：</p>
                <a-range-picker style="width:75%" @change="onChange" />
            </div>
            
            <div style="display:flex;margin:20px 0px 0px 0px">
                <p>用印类型：</p>
                <a-select style="width:75%" allowClear v-model="searchFrom.type" >
                    <a-select-option  value="党章">党章</a-select-option>
                    <a-select-option  value="行政公章">行政公章</a-select-option>
                </a-select>
            </div>
        </a-modal>
    </div>
    
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,list,del,approve,exportFile,batchApprove,exportXlsFile } from '@/baseAPI/undergraduate/culture/seal'
    import { getSchoolYear,getSemester,selectedMultiCheck } from '@/baseAPI/util'
    import { queryDepartmentTreeList } from '@/baseAPI/department'
    const columns = [
        {
            title: '序号',
            align:'center',
            width:'5%',
            customRender: (text, row, index) => {
                return { children: index+1+''};
            },
        },
        {
            title: '流水号',
            dataIndex: 'serialNumber',
            align:'center',
        },
        {
            title: '教师姓名',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '教师编号',
            dataIndex: 'teacherId',
            align:'center'
        },
        {
            title: '用章类型',
            dataIndex: 'type',
            align:'center'
        },
        {
            title: '材料份数',
            dataIndex: 'materialNumber',
            align:'center'
        },
        {
            title: '用章事由',
            dataIndex: 'targetUse',
            align:'center'
        },
        {
            title: '电话',
            dataIndex: 'telPhone',
            align:'center',
        },
        {
            title: 'email',
            dataIndex: 'email',
            align:'center',
        },
        {
            title: '状态',
            dataIndex: 'approvalStatus',
            align:'center',
            customRender:(text,row,inde)=>{
                let status
                if(text == 'draft'){
                    status='草稿'
                }else if(text == 'commit'){
                    status='审核中'
                }else if(text == 'approved'){
                    status='已审核'
                }else if(text == 'reject'){
                    status='已驳回'
                }
                return status
            }
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align:'center',
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                departmentTree: [],
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    orgCode:''
                },
                xbArr:[],
                xxArr:[],
                kclbArr:[],
                permissions:[],
                year:'',
                yearShowOne:false,
                loading: false,
                visible: false,
                info:{
                    approvalStatus: '',
	                kcbIds: [],
	                spyj: ''
                },
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                batchVisible: false,
                batchConfirmLoading: false,
                batchTitle:'',
                batchApproveInfo:{
                    approvalComments:'',
                    ids:[]
                },
                exportVisible: false,
                exportConfirmLoading: false,
                exportTitle:'',
                startDate:'',
                endDate:''
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'CAMPUS',status:true}).then(res=>{
                this.xxArr=res.data.dicts;
            })
            getDicts({dataCode:'KCLB',status:true}).then(res=>{
                this.kclbArr=res.data.dicts;
            })
            queryDepartmentTreeList().then((res) => {
                this.departmentTree = res.data
            })
            this.searchFrom.xn=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.searchFrom.xq=getSemester()
            this.fetch()
        },
        methods:{
            async batchExportFile(){
                for(let i of this.selectedRowKeys){
                    await new Promise((resolve) => {
                        setTimeout(() => {
                            this.downloadBlob(i)
                            resolve()
                        }, 1100);
                    })
                }
            },
            downloadBlob(id) {
                exportFile(id).then(res=>{
                    if(res){
                        const x = new XMLHttpRequest();
                        x.open("GET", this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data, true);
                        x.responseType = "blob";
                        x.onload = () => {
                            const url = URL.createObjectURL(x.response);
                            const a = document.createElement("a");
                            a.href = url;
                            a.download = res.data;
                            a.target = "_blank";
                            a.click();
                        };
                        x.send();
                        this.$notification['success']({
                            message: '成功',
                            description:'导出用印申请成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            exportXlsFile(){
                if(this.startDate != '' && this.startDate != null && this.searchFrom.type != null && this.searchFrom.type != ''){
                    exportXlsFile("startDate="+this.startDate+"&endDate="+this.endDate+"&type="+this.searchFrom.type).then(res=>{
                        if(res){
                            this.$notification['success']({
                                message: '成功',
                                description:'导出用印申请成功',
                            });
                            window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                    this.exportVisible = false;
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择时间范围及用印类型后再进行导出',
                    });
                }
            },
            showBatchModal(text) {
                this.batchVisible = true;
                this.batchTitle='用印申请-'+text
            },
            batchHandleCancel(e) {
                this.batchVisible = false;
                this.batchConfirmLoading = false;
            },
            showExportModal(text) {
                this.exportVisible = true;
                this.exportTitle='用印申请-'+text
            },
            exportHandleCancel(e) {
                this.exportVisible = false;
                this.exportConfirmLoading = false;
            },
            onChange(date, dateString) {
                this.startDate = dateString[0]+" 00:00:00"
                this.endDate = dateString[1]+" 23:59:59"
                console.log(date, dateString);
            },
            selectedCheck(){
                selectedMultiCheck()
            },
            batchSub(operation){
                this.batchApproveInfo.ids = this.selectedRowKeys;
                batchApprove(operation,this.batchApproveInfo).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'批量审核成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                    this.fetch();
                })
                this.batchVisible = false;
            },
            exportFile(id){
                if(this.selectedRowKeys.length>0){
                    exportFile(id).then(res=>{
                        if(res){
                            this.$notification['success']({
                                message: '成功',
                                description:'导出用印申请成功',
                            });
                            window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择用印申请后再进行导出',
                    });
                }
            },
            onChangeDep (value) {
                this.searchFrom.orgCode = value
            },
            exportTable(){
                exportTable(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            }, 
            showModal() {
                this.visible = true;
            },
            handleOk(approvalStatus) {
                
                if(approvalStatus!=''){
                    this.loading = true;
                    this.info.approvalStatus=approvalStatus
                    this.info.kcbIds=this.selectedRowKeys
                    batchApprove(this.info).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'用印申请'+(approvalStatus=='approved'?'审批通过':'驳回成功'),
                            });
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.visible = false;
                        this.loading = false;
                    })
                }else{
                    this.visible = false;
                }
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data=res.data.records
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(){
                if(this.selectedRowKeys.length==1){
                    del(this.selectedRowKeys[0]).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除用印申请成功',
                            });
                            this.selectedRowKeys = []
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else if(this.selectedRowKeys.length > 1){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能选择一行进行删除',
                    });
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择平行班后再进行删除',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.xn=getSchoolYear()+'-'+(getSchoolYear()+1)
                this.searchFrom.xq='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            seal(type){
                if(this.selectedRowKeys.length==1){
                    this.$router.push('/admin/office/seal/info?type='+type+'&id='+this.selectedRowKeys[0])
                }else if(this.selectedRowKeys.length > 1){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能选择一行',
                    });
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择用印申请记录',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
